import React, { useEffect, useState } from "react";
import { Stack, Box, Grid } from "@mui/material";
import EmailList from "./emailList";
import { useNavigate } from "react-router-dom";
import Button from "../../components/common/Button";
import { API, MONTH_NAMES, APP_ROUTES } from "../../globals/constants/index";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import "./emailTemplate.scss";
import api_call from "../../globals/common_utilities/axios_old";
import Pagination from "@mui/material/Pagination";
import DateRangePicker from "../../components/TP_DateRangePicker";
import moment from "moment";
import SearchBar from "../common/searchBar";
import MultiLine_Spinner from "../multiline_spinner/Multiline_spinner";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "universal-cookie";

const Index = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const datefilter = async (range) => {
    let startDate = range[0];
    let endDate = range[1];
    let params = queryParam;

    range[0]
      ? (params.from_date = `${moment(startDate).format("YYYY-MM-DD")}`)
      : delete params.from_date;

    range[1]
      ? (params.end_date = `${moment(endDate).format("YYYY-MM-DD")}`)
      : delete params.from_date;

    //exportParams.end_date = `${endDate}`;
    setqueryParam({ ...params });
  };
  const limit = 12;

  const [queryParam, setqueryParam] = useState({
    limit: limit || 12,
    offset: 0,
    is_active: true,
    // from_date: moment(previousDate).format('YYYY-MM-DD'),
    // end_date: moment(currentDate).format('YYYY-MM-DD'),
  });
  const [pageCount, setPageCount] = useState();
  const [searchTerm, setSearchTerm] = useState();

  const createEmailTemplate = () => {
    navigate(APP_ROUTES.ROUTE_EMAILTEMPLATE, { state: {} });
  };
  const handleSearch = (e) => {
    console.log("dhfhdshfhf", e);
    setqueryParam({
      ...queryParam,
      search_term: e,
    });
  };
  const [emailTemplateList, setEmailTemplateList] = useState([]);
  const cookies = new Cookies();

  const {
    id,
    name,
    device_id,
    studio_id,
    role_id,
    role_code,
    token,
    token_uniq_id,
    email_id,
    username,
    is_email_verify,
  } = cookies.get("loginData");
  const getEmailTemplateList = async () => {
    setLoader(true);
    console.log("---------- Get Template List from API -----------------");
    if (role_code === "STUDIO_ADMIN") {
      queryParam.unique_id = studio_id;
    }
    const response = await api_call(
      // token,
      "GET",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
        API.END_POINTS.EMAIL_TEMPLATE_LISTING,
      queryParam,
      {},
      {}
    )
      .then((response) => {
        console.log("emailResponse", response?.data?.data);
        setEmailTemplateList(response?.data?.data?.rows);
        setPageCount(() => Math.ceil(response?.data?.data?.count / limit));
        setLoader(false);
        return response?.data?.data?.rows;
      })
      .catch(() => {
        toast.error("NO RECORD FOUND", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      });
  };

  const onPageClickhandler = (e, data) => {
    setqueryParam((prevState) => ({
      ...prevState,
      offset: Math.ceil((data - 1) * limit),
    }));
  };
  useEffect(() => {
    getEmailTemplateList();
  }, [queryParam]);
  useEffect(() => {
    setqueryParam({
      ...queryParam,
      offset: 0,
    });
  }, [pageCount]);
  return (
    <>
      <Stack direction="row" justifyContent={"space-between"}>
        {}
        <Stack className="larger_f_bold" m={"1%"}>
          {"Email Template"}
        </Stack>
        <Stack marginTop={"1%"} direction={{ sx: "coloumn", md: "row" }}>
          <Stack
            direction="row"
            flexWrap="wrap"
            marginBottom={{ xs: "3%", md: "1%" }}
          >
            <SearchBar searchChange={(e) => handleSearch(e)} />
          </Stack>
          <Button
            value="Create Template"
            role="primary"
            className="template_btn"
            onClick={createEmailTemplate}
          />
        </Stack>
      </Stack>
      <Box
        sx={{
          bgcolor: "#232135",
          height: "75vh",
          m: "1%",
          borderRadius: "5px",
        }}
        className="tc_mainBox"
      >
        {loader ? (
          <MultiLine_Spinner />
        ) : (
          <EmailList
            res={emailTemplateList}
            getEmailTemplateList={() => getEmailTemplateList()}
          />
        )}
      </Box>
      <Stack alignItems="end" marginTop={"-1%"} marginRight={"1%"}>
        <Pagination count={pageCount} onChange={onPageClickhandler} hidePrevButton={queryParam.offset === 0}/>
      </Stack>
    </>
  );
};

export default Index;
